import React, { useEffect } from 'react';
import { message, Tooltip } from 'antd';
import { CopyOutlined, InfoCircleOutlined } from '@ant-design/icons';

import { Switch } from 'antd';
import { Wrapper } from './styled';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import {
  refetchDimensionRelated,
  refetchFlowRelated,
  refetchMappedEventRelated,
  refetchMetricRelated,
} from '@src/emp-3.0/utils';
import getActualShareLink from '../common/Sharing/getActualShareLink';
import { initialPredefinedMappedEvents } from '@src/hooks/useInitialization';
import { queryClient } from '@src/routers/constants';
import { GET_PRESET_LIST_KEY } from '@src/api/emp/queryHooks';
import { GET_FLOW_LABELS, GET_JOURNEY_STAGES } from '@src/emp-3.0/utils/constants';

const Content = () => {
  const { userInfo } = useInitialInfoStore();
  const link = getActualShareLink(
    '/app/app-insights/dashboard/app-experience',
    userInfo.workbench_account,
  );
  return (
    <div>
      <div>
        • Copy URL: {link.substring(0, 25)}...{' '}
        <CopyOutlined
          style={{ cursor: 'pointer' }}
          onClick={() => {
            navigator.clipboard.writeText(link);
            message.success('Link copied to clipboard');
          }}
        />
      </div>
      <div>• Open the URL in an incognito window</div>
    </div>
  );
};
const Workbench = () => {
  const { workbenchMode, setWorkbenchMode, userInfo, setPredefinedMappedEvents } =
    useInitialInfoStore();

  useEffect(() => {
    if (userInfo.is_workbench_account) {
      setWorkbenchMode(true);
    }
  }, [userInfo.is_workbench_account, setWorkbenchMode]);

  useEffect(() => {
    // refetch initial predefined mapped event
    Promise.all([initialPredefinedMappedEvents()]).then(([predefinedMappedEvents]) => {
      // Predefined Events
      setPredefinedMappedEvents([...predefinedMappedEvents]);
    });
    refetchMappedEventRelated();
    refetchMetricRelated();
    refetchDimensionRelated();
    refetchFlowRelated();
    queryClient.invalidateQueries([GET_PRESET_LIST_KEY]);
    // Invalidate label and journey stage queries when toggling workbench mode
    queryClient.invalidateQueries([GET_FLOW_LABELS]);
    queryClient.invalidateQueries([GET_JOURNEY_STAGES]);
  }, [workbenchMode]);

  if (!userInfo.show_workbench_toggle) return null;

  return (
    <Wrapper isDisabled={!workbenchMode}>
      {workbenchMode && (
        <Tooltip
          title={<Content />}
          placement="bottomLeft"
          overlayInnerStyle={{
            color: '#fff',
            fontSize: 12,
            borderRadius: 8,
            background: '#222',
            lineHeight: 1.6,
            minWidth: 240,
          }}
        >
          <InfoCircleOutlined style={{ marginRight: '4px' }} />
          How to preview in Trends (Workbench)
        </Tooltip>
      )}
      <Switch
        size="small"
        checked={workbenchMode}
        onChange={(checked) => setWorkbenchMode(checked)}
        style={{
          backgroundColor: workbenchMode ? '#FA8C16' : 'black',
        }}
      />{' '}
      Workbench Mode
    </Wrapper>
  );
};

export default Workbench;
